/**
 * Business Model Queue Strategy - handles business model discovery with queue-driven approach
 * Similar to education strategy but for business models (Recent/Current/Past Company Business Model)
 */

import { generateBusinessModelData } from './businessModel/queueUtils';
import { StrategyPhase } from './baseStrategy';

/**
 * Business Model queue strategy function
 * @param {Object} decision - Current decision object
 * @param {Array} messages - Current conversation messages
 * @param {Object} queries - Queries object
 * @returns {Object} Updated decision object
 */
const businessModelQueueStrategy = async (decision, messages, queries = {}) => {
  console.log('🏢 BUSINESS MODEL QUEUE STRATEGY - Processing business model topic');
  
  try {
    // Generate business model data and populate central queue with 3 items:
    // 1. Recent Company Business Model distribution bar chart
    // 2. Current Company Business Model distribution bar chart  
    // 3. Past Company Business Model distribution bar chart
    await generateBusinessModelData(messages, null, decision, true);
    
    console.log('🏢 BUSINESS MODEL QUEUE STRATEGY: Successfully populated central queue');
    
    return {
      ...decision,
      actionType: 'CONTINUE_DISCOVERY',
      strategyPhase: StrategyPhase.CONVERSATION
    };
    
  } catch (error) {
    console.error('🏢 BUSINESS MODEL QUEUE STRATEGY: Error:', error);
    
    // Fall back to normal conversation
    return {
      ...decision,
      actionType: 'SEND_TO_BACKEND',
      agentGuidance: 'Let\'s discuss the business model preferences for this role. What types of company business models are you interested in?',
      strategyPhase: StrategyPhase.CONVERSATION
    };
  }
};

export default businessModelQueueStrategy;